<template>
    <div v-loading="loading" class="billManage">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="日期：">
                    <el-date-picker
                        style="width:120px;"
                        @change="search"
                        format="YYYY-MM"
                        value-format="YYYYMM"
                        v-model="formInline.month"
                        type="month"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="地区：">
                    <el-select v-model="formInline.region" clearable style="width:120px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in regionList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Payers：" v-if="curRole!='customer'">
                    <el-select v-model="formInline.payer_id" clearable filterable style="width:120px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in payersList"
                            :key="index"
                            :label="item.name+'('+item.payer_id+')'"
                            :value="item.payer_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售：" v-if="curRole=='admin'">
                    <el-select clearable filterable v-model.trim="formInline.sales" placeholder="请选择" @change="search" style="width:120px">
                        <el-option
                            v-for="item in salesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合作伙伴：" v-if="curRole=='admin'||curRole=='sales'">
                    <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="请选择" @change="search" style="width:120px">
                        <el-option
                            v-for="item in agentsList"
                            :key="item.agent_id"
                            :label="item.company"
                            :value="item.agent_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账单类型：">
                    <el-select filterable v-model.trim="formInline.billType" placeholder="请选择" @change="search" style="width:120px">
                        <el-option
                            v-for="item in billTypeList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="LinkId：">
                    <el-input v-model="formInline.link_id" clearable style="width:120px" @change="search" placeholder="输入linkId查询"></el-input>
                </el-form-item>
                <el-form-item><el-button  @click="search" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item><el-button  @click="reset" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item label="">
                    <el-button  @click="selected.length>0?downloadTheBillByUrl(1):downloadTheBillByUrl(2)" type="primary" icon="Download">下载账单</el-button>
                    <el-button  @click="selected.length>0?downloadRightBill(1):downloadRightBill(2)" type="success" icon="Download">下载对账单</el-button>
                    <el-button v-if="curRole!='customer'" :disabled="!canConfirm"  @click="confirmBill" type="warning" icon="FolderAdd">确认账单</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table">
            <!-- 当前角色是客户的时候，如果请求的这一页数据都是0,则隐藏，否则不隐藏，涉及三列（credit，savingPlan，bundle） -->
            <el-table :height="'calc('+(tableHeight)+'px)'" stripe :data="tableData" ref="tableref" v-loading="loadingPage" @selection-change="selectionChange" style="width: 100%">
                <!-- <el-table-column
                    :selectable="isRowSelectable"
                    type="selection"
                    width="30"> -->
                <el-table-column
                    type="selection"
                    width="30">
                </el-table-column>
                <el-table-column label="LinkerId" width="150">
                    <!-- 灰色：账单未生成
                    黄色：销售待确认
                    橘色：伙伴待确认
                    绿色：账单已确认
                    样式用标签的形式，不用圆点了 -->
                    <template #default="scope">
                        <div style="display: flex;align-items: center;">
                            <el-tooltip :content="computeDate()?'销售待确认':'账单未生成'" placement="right" effect="customized" v-if="scope.row.locked==0||scope.row.locked==null">
                                <span>
                                    <img style="width:10px;margin-right:6px;cursor:pointer;" :src="computeDate()?require('../../assets/img/yellow.png'):require('../../assets/img/gray.png')" alt="">
                                    <span v-if="curRole=='customer'">{{ scope.row.linkId }}</span>
                                    <span style="cursor:pointer" v-if="curRole!='customer'" @click="downloadTheBillByUrl(1,scope.row.linkId)">{{ scope.row.linkId }}</span>
                                </span>
                            </el-tooltip>
                            <el-tooltip content="伙伴待确认" placement="right" effect="customized" v-if="scope.row.locked==1">
                                <span>
                                    <img style="width:10px;margin-right:6px;cursor:pointer;" :src="require('../../assets/img/orange.png')" alt="">
                                    <span v-if="curRole=='customer'">{{ scope.row.linkId }}</span>
                                    <span style="cursor:pointer" v-if="curRole!='customer'" @click="downloadTheBillByUrl(1,scope.row.linkId)">{{ scope.row.linkId }}</span>
                                </span>
                            </el-tooltip>
                            <el-tooltip content="伙伴已拒绝" placement="right" effect="customized" v-if="scope.row.locked==3">
                                <span>
                                    <img style="width:10px;margin-right:6px;cursor:pointer;" :src="require('../../assets/img/red.png')" alt="">
                                    <span v-if="curRole=='customer'">{{ scope.row.linkId }}</span>
                                    <span style="cursor:pointer" v-if="curRole!='customer'" @click="downloadTheBillByUrl(1,scope.row.linkId)">{{ scope.row.linkId }}</span>
                                </span>
                            </el-tooltip>
                            <el-tooltip content="账单已确认" placement="right" effect="customized" v-if="scope.row.locked==2">
                                <span>
                                    <img style="width:10px;margin-right:6px;cursor:pointer;" :src="require('../../assets/img/green.png')" alt="">
                                    <span v-if="curRole=='customer'">{{ scope.row.linkId }}</span>
                                    <span style="cursor:pointer" v-if="curRole!='customer'" @click="downloadTheBillByUrl(1,scope.row.linkId)">{{ scope.row.linkId }}</span>
                                </span>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="客户名称" width="200">
                    <template #default="scope">
                        <div style="display:flex;align-items: center;">
                            <span style="width:190px;display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" :title="scope.row.company">{{scope.row.company}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Payer Name" width="200">
                    <template #default="scope">
                        <!-- {{payersList.filter((item:any)=>item.payer_id==scope.row.payerId)[0].name}} -->
                         <span v-if="scope.row.payerId">{{payersList.filter(item=>item.payer_id==scope.row.payerId)[0]?.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="类别">
                    <template #default="scope">
                        {{ scope.row.entity }}
                    </template>
                </el-table-column>
                <el-table-column label="账单年月" width="80">
                    <template #default="scope">
                        {{scope.row.month.toString().substring(0,4)+'-'+scope.row.month.toString().substring(4,6)}}
                    </template>
                </el-table-column>
                <el-table-column label="Charge" align="right">
                    <template #default="scope">
                        {{Number(scope.row.charge).toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column v-if="!(curRole=='customer'&&!showCredit)" label="Credit" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.credit).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="Discount" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.discount_distributor).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="Tax" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.tax).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column v-if="!(curRole=='customer'&&!showSavingPlan)"  label="SavingPlans" align="right">
                    <template #default="scope">
                        {{Number(scope.row.spNegation).toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column v-if="!(curRole=='customer'&&!showBundle)"  label="Bundle" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.bundledDiscount).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="TotalCost" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.costTotal).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right"  align="center" v-if="curRole!='customer'">
                    <template #default="scope">
                        <div style="display:flex;align-items: center;justify-content: center;" v-if="(this.curRole=='sales'||this.curRole=='admin')&&(scope.row.locked==0 || scope.row.locked==null|| scope.row.locked==3)">
                            <el-tooltip content="重新计算账单" placement="top" effect="customized">
                                <el-button :disabled="canCompute" type="primary" link @click="reCompute(scope.row.payerId,scope.row.linkId)"><img :src="require('../../assets/img/reCompute.png')" style="width:15px;"></el-button>
                            </el-tooltip>
                            <el-tooltip content="重新下载原始账单" placement="top" effect="customized">
                                <el-button :disabled="canDownload" type="success" link @click="reDownload(scope.row.payerId,scope.row.linkId)"><img :src="require('../../assets/img/reDownload.png')" style="width:15px;"></el-button>
                            </el-tooltip>
                            <el-tooltip content="添加增值服务" placement="top" effect="customized">
                                <el-button link @click="addService(scope.row)" type="danger" icon="Plus"></el-button>
                            </el-tooltip>
                        </div>
                        <el-tooltip v-if="curRole=='agent'&&scope.row.locked==1" content="拒绝账单" placement="top" effect="customized">
                            <el-button link @click="refuseBill(scope.row.id)" type="danger" icon="CircleCloseFilled"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <el-dialog width="40%" class="service-dialog" v-model="serviceVisible" :close-on-click-modal="false" title="VAP增值服务">
            <el-table stripe :data="serviceData" style="width: 100%">
                <el-table-column label="服务描述">
                    <template #default="scope">
                        {{ scope.row.serviceName }}
                    </template>
                </el-table-column>
                <el-table-column label="税前金额" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.cost).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="税点" align="right">
                    <template #default="scope">
                        {{ (Number(scope.row.tax)*100).toFixed(2)+'%' }}
                    </template>
                </el-table-column>
                <el-table-column label="总计" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.costAgent).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template #default="scope">
                        <el-button type="primary" @click="editService(scope.row)" icon="Edit"></el-button>
                        <el-button type="danger" @click="removeService(scope.row)" icon="Delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-form :inline="true" :model="addForm" label-position="right" label-width="72" style="margin-top:30px;">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="税前金额：">
                            <el-input v-model="addForm.cost" @input="costChange" placeholder="请输入税前金额"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="税点：">
                            <el-input v-model="addForm.tax" @input="taxChange" placeholder="请输入税点"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="总计：">
                            <el-input type="number" v-model="addCostTotal" readonly disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="描述：" style="width:calc(100% - 32px)">
                            <el-input maxlength="10" v-model="addForm.serviceName" placeholder="请输入描述"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <el-button type="primary" @click="init">新增服务</el-button>
                <el-button type="success" @click="isEditService?editServiceSubmit():addServiceSubmit()">提交</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {downloadBillByBlob,downloadBillByUrl,getBillList,downloadBillDetail,reGenerateBill,reDownloadBill,saleConfirmBill,
        agentConfirmBill,getServiceData,addServiceBill,delServiceBill,getSalesList,getAgentList,getPayerList} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    export default {
        components:{
            Pagination
        },
        name:'billManage',
        data() {
            return {
                loading:false,
                loadingPage:false,
                tableHeight:500,
                formInline:{
                    month:'',
                    region:'',
                    payer_id:'',
                    link_id:'',
                    sales:'',
                    agent_id:'',
                    billType:2,
                    page: 1,
                    limit: 20,
                },
                addForm:{
                    cost:'',
                    tax:'',
                },
                addCostTotal:0,
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                tableData:[],
                payersList:[],
                salesList:[],
                agentsList:[],
                billTypeList:[
                    {name:'总代应付',value:1},
                    {name:'伙伴应付',value:2},
                    {name:'客户应付',value:3},
                ],
                regionList:[
                    {label:'全部',value:''},
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'}
                ],
                curRole:localStorage.getItem('curRole'),
                curDate:'',
                selected:[],
                canConfirm:false,

                showCredit:true,
                showSavingPlan:true,
                showBundle:true,
                serviceVisible:false,
                curRow:null,
                serviceData:null,
                isEditService:false,
                confirmSelected:[],
                canCompute:false,
                canDownload:false,
            }
        },

        created() {
            this.permissionData();
            let date = new Date();
            //获取当前年份的后一年
            let endY =date.getFullYear();
            //获取当前月
            let endM = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1 ) : date.getMonth()+1);
            let endD = date.getDate()<10?'0'+date.getDate():date.getDate();
            // 获取当前时间的时间戳
            this.curDate=(new Date(endY+'-'+endM+'-'+endD).getTime())/1000;
            this.formInline.month=endY.toString()+endM.toString();
            if(localStorage.getItem('billManageForm')){
                this.formInline = JSON.parse(localStorage.getItem('billManageForm'))
            }
            if(this.curRole=='sales'){
                this.formInline.sales = localStorage.getItem('account')
            }else if(this.curRole == 'agent'){
                this.formInline.agent_id = localStorage.getItem('account');
                this.billTypeList=[
                    {name:'伙伴应付',value:2},
                    {name:'客户应付',value:3},
                ]
            }else if(this.curRole == 'customer'){
                this.billTypeList=[
                    {name:'客户应付',value:3},
                ]
                this.formInline.billType = 3;
            }
            this.getData();
        },
        methods:{
            //获取列表
            getData() {
                this.loadingPage = true;
                this.tableData = [];
                this.formInline.link_id = this.formInline.link_id.trim();
                getBillList(this.formInline).then(res => {
                    this.loadingPage = false
                    if(res.code ==2000) {
                        this.tableData = res.data;
                        var num1=0,num2=0,num3=0;
                        this.tableData.forEach(el=>{
                            num1 = Number(num1) + Number(el.credit);
                            num2 = Number(num2) + Number(el.spNegation);
                            num3 = Number(num3) + Number(el.bundledDiscount);
                        })
                        if(num1==0){
                            this.showCredit = false;
                        }
                        if(num2==0){
                            this.showSavingPlan = false;
                        }
                        if(num3==0){
                            this.showBundle = false;
                        }
                        this.pageparm.page = res.page;
                        this.pageparm.limit = res.limit;
                        this.pageparm.total = res.total;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            permissionData(){
                if(this.curRole=='admin'){
                    this.getAgentsList();
                    this.getSaleList();
                    this.getPayersList();
                }else if(this.curRole == 'sales'){
                    this.getAgentsList();
                    this.getPayersList();
                }else if(this.curRole == 'agent'){
                    this.getPayersList();
                }
            },
            // 获取伙伴列表
            getAgentsList(){
                getAgentList({company:'',payers:'',sales:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.agentsList = res.data.data;
                    }else{
                        this.$message.error('获取伙伴列表失败！');
                    }
                })
            },
            // 获取销售列表
            getSaleList(){
                getSalesList({name:'',phone:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.salesList = res.data.data;
                    }else{
                        this.$message.error('获取销售列表失败！');
                    }
                })
            },
            // 获取payer列表
            getPayersList(){
                getPayerList({name:'',payer_id:'',region:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.payersList = res.data.data;
                    }else{
                        this.$message.error('获取Payer列表失败！');
                    }
                })
            },
            // 通过文件流下载
            downloadTheBillByBlob(type,linkId){
                if(linkId){//点击linkId下载单个
                    downloadBillByBlob({link_id:linkId,month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                        if(res.size<=73){
                            this.$message.error('无账单文件，请联系管理员！')
                        }else{
                            const url = window.URL.createObjectURL(res) // 将二进制文件转换为可访问的url
                            const a = document.createElement('a')
                            document.body.appendChild(a)
                            a.href = url
                            a.download = '单个账单.zip'
                            a.click()
                            window.URL.revokeObjectURL(url)
                        }
                    })
                }else{
                    if(type==1){//下载选中账单
                        var arr=[];
                        this.selected.forEach(el=>{
                            arr.push(el.linkId)
                        })
                        downloadBillByBlob({link_id:arr.join(','),month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                            if(res.size<=73){
                                this.$message.error('无账单文件，请联系管理员！')
                            }else{
                                const url = window.URL.createObjectURL(res) // 将二进制文件转换为可访问的url
                                const a = document.createElement('a')
                                document.body.appendChild(a)
                                a.href = url
                                a.download = '单个账单.zip'
                                a.click()
                                window.URL.revokeObjectURL(url)
                            }
                        })
                    }else{//下载全部账单
                        downloadBillByBlob(this.formInline).then(res=>{
                            if(res.size<=73){
                                this.$message.error('无账单文件，请联系管理员！')
                            }else{
                                const url = window.URL.createObjectURL(res) // 将二进制文件转换为可访问的url
                                const a = document.createElement('a')
                                document.body.appendChild(a)
                                a.href = url
                                a.download = '单个账单.zip'
                                a.click()
                                window.URL.revokeObjectURL(url)
                            }
                        })
                    }
                }
            },
            // 通过地址下载
            downloadTheBillByUrl(type,linkId){
                this.loading = true;
                if(linkId){//点击linkId下载单个
                    downloadBillByUrl({link_id:linkId,month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }else{
                    if(type==1){//下载选中账单
                        var arr=[];
                        this.selected.forEach(el=>{
                            arr.push(el.linkId)
                        })
                        downloadBillByUrl({link_id:arr.join(','),month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                            this.loading = false;
                            if(res.code==2000){
                                if(res.data){
                                    this.downloadFile(res.data)
                                }else{
                                    this.$message.error(JSON.stringify(res.msg));
                                }
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }else{//下载全部账单
                        downloadBillByUrl(this.formInline).then(res=>{
                            this.loading = false;
                            if(res.code==2000){
                                if(res.data){
                                    this.downloadFile(res.data)
                                }else{
                                    this.$message.error(JSON.stringify(res.msg));
                                }
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }
                }
            },
            // 下载
            downloadFile(url){
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.href = url
                a.click()
                setTimeout(()=>{
                    a.remove()
                },1000)
            },
            isRowSelectable(row,index){
                // if(row.locked!=2&&this.computeDate()){
                //     return true;
                // }else{
                //     return false;
                // }
                if(this.curRole=='agent'){
                    return row.locked==1
                }else{
                    return row.locked==0 && this.computeDate();
                }

            },
            // 复选框勾选
            selectionChange(val){
                this.selected=val;
                if(this.selected.length>0){
                    if(this.curRole=='agent'){
                        this.confirmSelected = val.filter(item=>{
                            return item.locked == 1;
                        })
                    }else{
                        this.confirmSelected = val.filter(item=>{
                            return (item.locked==0||item.locked==3) && this.computeDate();
                        })
                    }
                    if(this.confirmSelected.length>0){
                        this.canConfirm = true;
                    }else{
                        this.canConfirm = false;
                    }
                }else{
                    this.canConfirm = false;
                }
            },
            // 重新计算账单
            reCompute(payerId,linkId){
                this.canCompute = true;
                reGenerateBill({month:this.formInline.month,payerId:payerId,linkId:linkId}).then(res=>{
                    if(res.code ==2000){
                        this.$message.success(res.msg);
                        this.canCompute = false;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 重新下载原始账单
            reDownload(payerId,linkId){
                this.canDownload = true;
                reDownloadBill({month:this.formInline.month,payerId:payerId,linkId:linkId}).then(res=>{
                    if(res.code ==2000){
                        this.$message.success(res.msg);
                        this.canDownload = false;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            downloadRightBill(type){
                this.loading = true;
                if(type==1){//下载选中账单
                    var arr=[];
                    this.selected.forEach(el=>{
                        arr.push(el.linkId)
                    })
                    downloadBillDetail({link_id:arr.join(','),month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }else{//下载全部账单
                    downloadBillDetail(this.formInline).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }
            },
            addService(obj){
                this.curRow = JSON.parse(JSON.stringify(obj));
                this.getSData();
                setTimeout(()=>{
                    this.serviceVisible = true;
                    this.isEditService = false;
                },200)
            },
            getSData(linkId){
                getServiceData({linkId:this.curRow.linkId,month:this.formInline.month}).then(res=>{
                    if(res.code==2000){
                        this.serviceData = res.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            init(){
                this.addForm={
                    cost:'',
                    tax:'',
                    serviceName:'',
                }
                this.addCostTotal = 0;
                this.isEditService =false;
            },
            costChange(val){
                this.addForm.cost = val.replace(/[^\d.]/g,'');
                if(this.addForm.tax){
                    this.addCostTotal =((Number(this.addForm.cost) * (Number(this.addForm.tax)+100))/100).toFixed(2);
                }else{
                    this.addCostTotal = this.addForm.cost;
                }
            },
            taxChange(val){
                this.addForm.tax = val.replace(/[^\d.]/g,'');
                if(this.addForm.cost){
                    this.addCostTotal =((Number(this.addForm.cost) * (Number(this.addForm.tax)+100))/100).toFixed(2);
                }else{
                    this.addCostTotal = 0;
                }
            },
            addServiceSubmit(){
                var obj={
                    linkId:this.curRow.linkId,
                    payerId:this.curRow.payerId,
                    month:this.formInline.month,
                    serviceCode:this.addForm.serviceName,
                    entity:this.curRow.entity
                }
                this.addForm.tax = this.addForm.tax / 100;
                addServiceBill({...obj,...this.addForm}).then(res=>{
                    if(res.code==2000){
                        this.$message.success('添加服务成功！');
                        this.init();
                        this.getSData();
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            editService(obj){
                this.addForm = JSON.parse(JSON.stringify(obj));
                this.addForm.tax = this.addForm.tax*100;
                this.isEditService = true;
            },
            removeService(obj){
                this.$confirm('确定删除该服务吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(()=>{
                    delServiceBill({id:obj.id,linkId:obj.linkId}).then(res=>{
                        if(res.code==2000){
                            this.getSData();
                            this.$message.success('删除成功！')
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                })
            },
            editServiceSubmit(){
                this.addForm.tax = this.addForm.tax / 100;
                addServiceBill(this.addForm).then(res=>{
                    if(res.code==2000){
                        this.$message.success('修改服务成功！');
                        this.init();
                        this.getSData();
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },

            confirmBill(){
                var txt="账单一经确认，将会锁定账单且无法修改，是否继续？";
                if(this.curRole == 'agent'){
                    txt = '橘色标记的账单将确认，'+txt;
                }else if(this.curRole=='admin'||this.curRole=='sales'){
                    txt = '黄色标记的账单将确认，'+txt;
                }
                this.$confirm(txt,'提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消'
                }).then(()=>{
                    var arr=[];
                    this.confirmSelected.forEach(el=>{
                        arr.push(el.id)
                    })
                    if(this.curRole=='agent'){//伙伴确认账单
                        // result参数，2是确认账单，3是拒绝账单
                        agentConfirmBill({id:arr.join(','),result:2}).then(res=>{
                            if(res.code==2000){
                                this.$message.success('账单已确认成功！');
                                this.getData()
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }else{//销售或admin确认账单
                        saleConfirmBill({id:arr.join(',')}).then(res=>{
                            if(res.code==2000){
                                this.$message.success('账单已确认成功，请通知伙伴确认账单！');
                                this.getData()
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }
                })
            },
            refuseBill(id){
                this.$confirm('拒绝该账单后，请及时联系销售人员，是否继续？','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消'
                }).then(()=>{
                    agentConfirmBill({id:id,result:3}).then(res=>{
                        if(res.code==2000){
                            this.$message.success('账单已拒绝，请通知销售查看账单！');
                            this.getData()
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                })
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit = 20
                this.getData()
                localStorage.setItem('billManageForm',JSON.stringify(this.formInline));
            },
            reset() {
                this.formInline = {
                    month:'',
                    region:'',
                    payer_id:'',
                    link_id:'',
                    sales:'',
                    agent:'',
                    billType:2,
                    page: 1,
                    limit: 20,
                }
                this.pageparm={
                    page: 1,
                    limit: 20,
                    total: 0
                }
                this.getData()
            },
            //计算当前日期和筛选日期，如果当前月份-1=筛选月份，并且当前日期大于等于10号，则该月份账单可确认，同时要根据lock来确定
            //lock=0 ：账单初始状态，可以根据上一条来判断，满足则显示黄色，不满足则显示灰色
            //lock=1 ：销售已确认状态，此时显示橘色
            //lock=2 ：代理商已确认，此时显示绿色，此时该link对应的返点不可调整，该link对应的账单，复选框无法选中标绿的这条记录
            // curDate - 1 == this.formInline.month.toString().substring(4,6)
            computeDate(){
                let date = new Date();
                //获取当前年份的后一年
                let endY =date.getFullYear();
                //获取当前月
                let endM = date.getMonth();
                let endD = date.getDate();
                let year='',month='';
                if(this.formInline.year){
                    year = Number(this.formInline.year.toString().substring(0,4));
                }
                if(this.formInline.month){
                    month = Number(this.formInline.month.toString().substring(4,6));
                }
                if(endY==year&&endM==month&&endD>=10){
                    return true
                }else if(endY==year&&endM>month){
                    return true;
                }else if(endY>year){
                    return true;
                }else{
                    return false;
                }
            },

            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                this.tableHeight =  getTableHeight(tabSelectHeight)
            },
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style lang="scss">
.billManage{
    .link-dialog{
        .el-form-item__label{
            font-weight: bold;
        }
    }
    .tableSelect{
        .billMngBtn{
            margin:0;
            border:1px solid #fff;
            // border-radius:0;
        }
    }
    .table{
        .el-table{
            .cell{
                .dot{
                    display: inline-block;
                    width:10px;
                    height:10px;
                    background:grey;
                    border-radius: 50%;
                    margin-right:6px;
                }
                .dot.yellow{
                    background:yellow;
                }
                .dot.orange{
                    background:orange;
                }
                .dot.green{
                    background:green;
                }
            }
        }
    }


}
.el-popper.is-customized {
    background: #000;
    color:#fff;
}
.el-popper.is-customized .el-popper__arrow::before {
    background: #000;
    right: 0;
}
</style>
